import { Outlet, RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@sidecar/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.projects.root,
    element: loadable(() => import('./pages/ProjectsPage')),
    children: [
      {
        path: paths.projects.children.details,
        element: loadable(() => import('./pages/ProjectDetails')),
        children: [
          {
            path: 'tickets',
            element: <Outlet />,
            children: [
              { path: 'new', element: <Outlet /> },
              {
                path: ':ticketId',
                element: <Outlet />,
                children: [
                  { path: 'edit', element: <Outlet /> },
                  { path: 'comments', element: <Outlet /> },
                  { path: 'comments/new', element: <Outlet /> },
                  { path: 'related-tasks', element: <Outlet /> },
                  { path: 'related-tasks/new', element: <Outlet /> },
                  { path: 'activity-log', element: <Outlet /> },
                ],
              },
            ],
          },
          {
            path: paths.projects.details.tab,
            element: <Outlet />,
          },
        ],
      },
    ],
  },
];
